<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns2"
  [noChangeLabel]="true"
  [erroremessage]="erroremessage"
  [saveLabel]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.Confirm' | translate"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="adresbox">
      <div class="col-lg-12">
        <ssg-radiobox
          name="AddressId"
          id="radioboxAddressId"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.AddressId' | translate"
          [items]="model.Addresses"
          textFieldName="Address"
          valueFieldName="Id">
        </ssg-radiobox>
      </div>
      <div class="col-lg-12">
        <ssg-radiobox
          name="PhoneId"
          id="radioboxPhoneId"
          [group]="formGroup"
          [items]="model.Numbers"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.radioboxPhoneId' | translate"
          textFieldName="Number"
          valueFieldName="Id">
        </ssg-radiobox>
      </div>
    </div>
  </ng-container>
</dynamic-form>
